import { render } from "./home.vue?vue&type=template&id=25d0abbc"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"
script.render = render

export default script